import { merge, withDefaultValue } from '@ally/validator';
import { DoesNotExceedInternalLimitValidator, HasAmountValidator, } from '../../shared';
import { DoesNotExceedAvailableBalanceValidator } from './DoesNotExceedAvailableBalance';
import { DoesNotExceedDistributionAmountValidator } from './DoesNotExceedDistributionAmount';
import { DoesNotExceedNewCustomerLimitValidator } from './DoesNotExceedNewCustomerLimit';
var validator = merge(HasAmountValidator, DoesNotExceedInternalLimitValidator, DoesNotExceedAvailableBalanceValidator, DoesNotExceedNewCustomerLimitValidator, DoesNotExceedDistributionAmountValidator);
export default withDefaultValue(validator, 0);
//# sourceMappingURL=index.js.map